import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Injectable } from "@angular/core";

@Injectable()
export class ValidationService {
  static getValidatorErrorMessage(validatorName: string, validatorValue?: any): string {
    const config: { [key: string]: string } = {
      required: 'Requerido',
      invalidEmailAddress: 'Dirección de correo no válida',
      invalidPassword:
        'Contraseña no válida. La contraseña debe tener al menos 6 caracteres de longitud, y contener un número.',
      minlength: `Longitud mínima ${validatorValue ? validatorValue.requiredLength : ''}`
    };

    return config[validatorName];
  }

  static emailValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

    return emailRegex.test(control.value)
      ? null
      : { invalidEmailAddress: true };
  }

  static passwordValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const passwordRegex = /^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/;

    return passwordRegex.test(control.value)
      ? null
      : { invalidPassword: true };
  }
}